import { UI, useDayPicker, RootProps } from "react-day-picker";

const classes = {
  Wrapper: "flex-1"
};

export const CalendarRoot = ({ children, rootRef, ...props }: RootProps) => {
  const dayPicker = useDayPicker();
  const components = dayPicker.components;
  const classNames = dayPicker.classNames;

  return (
    // rootRef is DayPicker's ref for the root element, not a DOM attribute
    <div ref={rootRef} {...props}>
      <div className={classes.Wrapper}>
        {children}
        <components.Footer className={classNames[UI.Footer]} />
      </div>
    </div>
  );
};
